import type { AnnouncementData } from '@/data/types';

interface AnnouncementBannerProps {
  announcement: AnnouncementData;
}

export function AnnouncementBanner({ announcement }: AnnouncementBannerProps) {
  if (!announcement.visible) {
    return null;
  }

  return (
    <div className="bg-black text-white text-center py-2 text-sm font-bold">
      {announcement.text}
    </div>
  );
}